const kia = {
  state: () => ({
    images: {
      sedans: [
        // {
        //   modelName: "Cadenza",
        //   sideView: require("../../../static/images/carcuts/kia/side-view/cadenza-19.png"),
        //   angleView: require("../../../static/images/carcuts/kia/angle-view/MISSING.png")
        // },
        {
          modelName: "Forte",
          sideView: require("../../../static/images/carcuts/kia/side-view/forte-19.png"),
          angleView: require("../../../static/images/carcuts/kia/angle-view/forte-21.png"),
          trims: ["FE", "LXS", "GT-Line", "EX", "GT"]
        },
        {
          modelName: "K5",
          sideView: require("../../../static/images/carcuts/kia/side-view/k5-21.png"),
          angleView: require("../../../static/images/carcuts/kia/angle-view/k5-21.png"),
          trims: ["LX", "LXS", "GT-Line", "EX", "GT"]
        },
        // {
        //   modelName: "Optima",
        //   sideView: require("../../../static/images/carcuts/kia/side-view/optima-19.png"),
        //   angleView: require("../../../static/images/carcuts/kia/angle-view/MISSING.png")
        // },
        {
          modelName: "Rio",
          sideView: require("../../../static/images/carcuts/kia/side-view/rio-19.png"),
          angleView: require("../../../static/images/carcuts/kia/angle-view/rio-21.png"),
          trims: ["LX", "S"]
        },
        {
          modelName: "Stinger",
          sideView: require("../../../static/images/carcuts/kia/side-view/stinger-19.png"),
          angleView: require("../../../static/images/carcuts/kia/angle-view/stinger-22.png"),
          trims: ["GT-Line", "GT", "GT2", "GT1"]
        },
      ],
      suvs: [
        {
          modelName: "Niro",
          sideView: require("../../../static/images/carcuts/kia/side-view/niro-19.png"),
          angleView: require("../../../static/images/carcuts/kia/angle-view/niro-21.png"),
          trims: ["LX", "LXS", "LXS Special Edition", "Touring Special Edition", "EX Premium"]
        },
        {
          modelName: "Sedona",
          sideView: require("../../../static/images/carcuts/kia/side-view/sedona-19.png"),
          angleView: require("../../../static/images/carcuts/kia/angle-view/sedona-21.png"),
          trims: ["LX", "EX", "SX"]
        },
        // {
        //   modelName: "Seltos",
        //   sideView: require("../../../static/images/carcuts/kia/side-view/MISSING.png"),
        //   angleView: require("../../../static/images/carcuts/kia/angle-view/seltos-21.png")
        // },
        {
          modelName: "Sorento",
          sideView: require("../../../static/images/carcuts/kia/side-view/sorento-19.png"),
          angleView: require("../../../static/images/carcuts/kia/angle-view/sorento-21.png"),
          trims: ["L", "LX", "SV6", "EX", "SX"]
        },
        {
          modelName: "Soul",
          sideView: require("../../../static/images/carcuts/kia/side-view/soul-19.png"),
          angleView: require("../../../static/images/carcuts/kia/angle-view/soul-22.png"),
          trims: ["LX", "S", "GT-Line", "X-Line", "EX", "Turbo"]
        },
        {
          modelName: "Sportage",
          sideView: require("../../../static/images/carcuts/kia/side-view/sportage-19.png"),
          angleView: require("../../../static/images/carcuts/kia/angle-view/sportage-22.png"),
          trims: ["LX", "Nightfall Edition", "EX", "SX Turbo"]
        },
        {
          modelName: "Telluride",
          sideView: require("../../../static/images/carcuts/kia/side-view/Telluride-Red.png"),
          angleView: require("../../../static/images/carcuts/kia/angle-view/telluride-21.png"),
          trims: ["LX", "S", "EX", "SX"]
        },
      ],
      trucks: [
      ],
      lifestyleImages: {
        defaultImage: require("../../../static/images/carcuts/kia/lifestyle/telluride-multi-2022.jpg"),
        sedanImage: require("../../../static/images/carcuts/kia/lifestyle/kia-jt-bg.jpg"),
        suvImage: require("../../../static/images/carcuts/kia/lifestyle/sorento-19.jpg"),
        truckImage: require("../../../static/images/carcuts/kia/lifestyle/telluride02-2022.jpg")
      },
      videoLink: [
        "https://player.vimeo.com/progressive_redirect/playback/999220257/rendition/1080p/file.mp4?loc=external&signature=b3e90fd4bebbb027b40d7604739279d2d2676970bd367f84e600d72ddbb44d42"
      ],
      roundButtons: [
        require("../../../static/images/buttons/round-buttons/kia-New.png"), require("../../../static/images/buttons/round-buttons/kia-Used.png"), require("../../../static/images/buttons/round-buttons/kia-ScheduleService.png"), require("../../../static/images/buttons/round-buttons/kia-Worth.png")
      ],
      browseButtons: [
        require("../../../static/images/buttons/browse-buttons/black-new.png"), require("../../../static/images/buttons/browse-buttons/black-used.png"), require("../../../static/images/buttons/browse-buttons/black-service.png"), require("../../../static/images/buttons/browse-buttons/black-specials.png")
      ],
      swoopIcons: [
        require("../../../static/images/buttons/swoop-icons/black01.png"), require("../../../static/images/buttons/swoop-icons/black03.png"), require("../../../static/images/buttons/swoop-icons/black02.png")
      ],
      homeBanners: [
        require("../../../static/images/banners/kia/CM-PW-24-Kia-Established.jpg"), require("../../../static/images/banners/kia/CM-PW-24-Kia-Lifestyle.jpg"), require("../../../static/images/banners/kia/CM-PW-24-Kia-Modern.jpg"), require("../../../static/images/banners/kia/CM-PW-24-Kia-Playful.jpg")
      ],
      stripBanners: [
        require("../../../static/images/banners/kia/SOKAL-SRS-112921-Telluride-Established.jpeg"), require("../../../static/images/banners/kia/SOKAL-SRS-112921-Telluride-Lifestyle.jpeg"), require("../../../static/images/banners/kia/SOKAL-SRS-112921-Telluride-Modern.jpeg"), require("../../../static/images/banners/kia/SOKAL-SRS-112921-Telluride-Playful-v2.jpeg")
      ],
      logoExample: [
        require("../../../static/images/buttons/logos/dd-logo-kia.png"),
        require("../../../static/images/buttons/logos/dd-logo-kia-w.png")
      ]
    },
   colors: {
      "--primary-color": "#05141f",
      "--primary-dark": "#05141f",
      "--primary-light": "#FFF",
      "--secondary-color": "#05141f",
      "--secondary-dark": "#000",
      "--secondary-light": "#F5f5f5",
    },
    fonts: {
      "--heading-text": "'Inter', sans-serif",
      "--subheading-text": "'Inter', sans-serif",
      "--body-text": "'Inter', sans-serif",
      "--bold-text": "'Inter', sans-serif"
    }
  })
}


export default kia